import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { PollListPage } from './PollListPage';
import { CreatePollPage } from './CreatePollPage';
import { PollPage } from './PollPage';

/**
 * Arche wrapper for Polls — provides ArcheLayout with sidebar
 * and handles sub-routing for all poll pages.
 */
export function PollsArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<PollListPage />} />
        <Route path="/create" element={<CreatePollPage />} />
        <Route path="/:pollId" element={<PollPage />} />
        <Route path="/:pollId/edit" element={<CreatePollPage />} />
      </Routes>
    </ArcheLayout>
  );
}
